var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolMachine2Machine01 = function SvgSolMachine2Machine01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_machine_2_machine-01_svg2__a",
    x1: 41.3,
    x2: 186.99,
    y1: 194.76,
    y2: 28.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_machine_2_machine-01_svg2__a",
    id: "sol_machine_2_machine-01_svg2__b",
    x1: -2.13,
    x2: 143.56,
    y1: 156.78,
    y2: -9.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_machine_2_machine-01_svg2__a",
    id: "sol_machine_2_machine-01_svg2__c",
    x1: -11.21,
    x2: 134.48,
    y1: 148.83,
    y2: -17.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_machine_2_machine-01_svg2__a",
    id: "sol_machine_2_machine-01_svg2__d",
    x1: 21.69,
    x2: 167.38,
    y1: 177.61,
    y2: 11.02
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_machine_2_machine-01_svg2__a",
    id: "sol_machine_2_machine-01_svg2__e",
    x1: 12.6,
    x2: 158.3,
    y1: 169.66,
    y2: 3.07
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_machine_2_machine-01_svg2__a",
    id: "sol_machine_2_machine-01_svg2__f",
    x1: 89.68,
    x2: 235.37,
    y1: 237.07,
    y2: 70.48
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_machine_2_machine-01_svg2__a",
    id: "sol_machine_2_machine-01_svg2__g",
    x1: 80.6,
    x2: 226.29,
    y1: 229.13,
    y2: 62.54
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M190 116.67h-26.67v-13.33c0-3.68-2.98-6.67-6.67-6.67h-53.33V83.34H120c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-4.07l-1.67-6.67h15.73c5.52 0 10-4.48 10-10V10C140 4.48 135.52 0 130 0H70c-5.52 0-10 4.48-10 10v50c0 5.52 4.48 10 10 10h15.73l-1.67 6.67h-4.07c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h16.67v13.33H43.33c-3.68 0-6.67 2.98-6.67 6.67v13.33H10c-5.52 0-10 4.48-10 10v50c0 5.52 4.48 10 10 10h15.73l-1.67 6.67h-4.07c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h40c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-4.07l-1.67-6.67h15.73c5.52 0 10-4.48 10-10v-50c0-5.52-4.48-10-10-10H43.31v-13.33h113.33v13.33h-26.67c-5.52 0-10 4.48-10 10v50c0 5.52 4.48 10 10 10h15.73l-1.67 6.67h-4.07c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h40c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-4.07l-1.67-6.67h15.73c5.52 0 10-4.48 10-10v-50c0-5.52-4.48-10-10-10ZM30.94 193.33l1.67-6.67H47.4l1.67 6.67zm42.39-16.66c0 1.84-1.49 3.33-3.33 3.33H10c-1.84 0-3.33-1.49-3.33-3.33v-3.33h66.67v3.33ZM70 123.33c1.84 0 3.33 1.49 3.33 3.33v40H6.67v-40c0-1.84 1.49-3.33 3.33-3.33zM66.67 10c0-1.84 1.49-3.33 3.33-3.33h60c1.84 0 3.33 1.49 3.33 3.33v40H66.66V10ZM70 63.33c-1.84 0-3.33-1.49-3.33-3.33v-3.33h66.67V60c0 1.84-1.49 3.33-3.33 3.33h-60Zm20.94 13.34L92.61 70h14.79l1.67 6.67zm35.73 50c0-1.84 1.49-3.33 3.33-3.33h60c1.84 0 3.33 1.49 3.33 3.33v40h-66.67v-40Zm24.27 66.66 1.67-6.67h14.79l1.67 6.67zm42.39-16.66c0 1.84-1.49 3.33-3.33 3.33h-60c-1.84 0-3.33-1.49-3.33-3.33v-3.33h66.67v3.33Z",
    style: {
      fillRule: "evenodd",
      fill: "url(#sol_machine_2_machine-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 40,
    r: 3.33,
    style: {
      fill: "url(#sol_machine_2_machine-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 13.33c-1.84 0-3.33 1.49-3.33 3.33v10c0 1.84 1.49 3.33 3.33 3.33s3.33-1.49 3.33-3.33v-10c0-1.84-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#sol_machine_2_machine-01_svg2__c)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 156.67,
    r: 3.33,
    style: {
      fill: "url(#sol_machine_2_machine-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 146.67c1.84 0 3.33-1.49 3.33-3.33v-10c0-1.84-1.49-3.33-3.33-3.33s-3.33 1.49-3.33 3.33v10c0 1.84 1.49 3.33 3.33 3.33",
    style: {
      fillRule: "evenodd",
      fill: "url(#sol_machine_2_machine-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 156.67,
    r: 3.33,
    style: {
      fill: "url(#sol_machine_2_machine-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 130c-1.84 0-3.33 1.49-3.33 3.33v10c0 1.84 1.49 3.33 3.33 3.33s3.33-1.49 3.33-3.33v-10c0-1.84-1.49-3.33-3.33-3.33",
    style: {
      fillRule: "evenodd",
      fill: "url(#sol_machine_2_machine-01_svg2__g)"
    }
  }));
};
export default SvgSolMachine2Machine01;